import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
} from 'antd';

import ModalPrintControls from './ModalPrintControls';

const { Text } = Typography;

const ModalPrint = ({
  onPrint,
  onCancel,
  content,
  open,
  loading,
}) => (
  <Modal
    title={(
      <Row justify="space-between">
        <Text>
          Imprimir
        </Text>
        <ModalPrintControls
          onPrint={onPrint}
          onCancel={onCancel}
          loading={loading}
        />
      </Row>
    )}
    className="modal-delete"
    open={open}
    footer={null}
    closable={false}
    maskClosable={!loading}
    keyboard={!loading}
    destroyOnClose
  >
    {typeof content === 'string' ? (
      <>
        <Text style={{ fontSize: 16 }}>
          ¿Desea Imprimir
          {' '}
          {content}
          ?
        </Text>
        <Text>
          Al imprimir este documento se guardará un registro en el historial, ¿Deseas continuar?
        </Text>
      </>
    ) : (
      content
    )}
  </Modal>
);

ModalPrint.propTypes = {
  onPrint: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  open: PropTypes.bool,
  loading: PropTypes.bool,
};

ModalPrint.defaultProps = {
  open: false,
  loading: false,
};

export default ModalPrint;
